import { z } from 'zod';
import { OrganizationBadgeSchema } from './organizationBadgeSchema';
export const OrganizationSimpleSchema = z.object({
    id: z.number().optional(),
    name: z.string().optional(),
    badges: z.array(OrganizationBadgeSchema).optional().default([]),
    logoUrl: z.string().optional().nullable()
});
//# sourceMappingURL=organizationSimpleSchema.js.map